import { createContext, useEffect, useState } from 'react';

import useLocalStorage from './local-storage-controller';

export enum SearchViewType {
  ComfortView = 'comfortView',
  LiteView = 'liteView',
}

export enum SLOCardViewType {
  GridView = 'gridView',
  ListView = 'listView',
}

export const SearchConfigContext = createContext({
  searchViewType: '',
  sloCardViewType: '',
  setSearchViewType: (_: SearchViewType) => {},
  setSLOCardViewType: (_: SLOCardViewType) => {},
});
SearchConfigContext.displayName = 'SearchConfigContext';

const useSearchConfigController = () => {
  const [searchViewType, setSearchViewType] = useState<SearchViewType>(SearchViewType.LiteView);
  const [sloCardViewType, setSLOCardViewType] = useState<SLOCardViewType>(SLOCardViewType.GridView);

  const [localStorageSearchViewType, setLocalStorageSearchViewType] = useLocalStorage(
    'tome-search-view-type',
    ''
  );
  const [localStorageSLOCardViewType, setLocalStorageSLOCardViewType] = useLocalStorage(
    'tome-search-slo-card-view-type',
    ''
  );

  useEffect(() => {
    if (localStorageSearchViewType === SearchViewType.ComfortView) {
      setLocalStorageSearchViewType(SearchViewType.ComfortView);
      setSearchViewType(SearchViewType.ComfortView);
    }
    if (localStorageSLOCardViewType === SLOCardViewType.ListView) {
      setLocalStorageSLOCardViewType(SLOCardViewType.ListView);
      setSLOCardViewType(SLOCardViewType.ListView);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    searchViewType,
    sloCardViewType,
    setSearchViewType: (type: SearchViewType) => {
      setLocalStorageSearchViewType(type);
      setSearchViewType(type);
    },
    setSLOCardViewType: (type: SLOCardViewType) => {
      setLocalStorageSLOCardViewType(type);
      setSLOCardViewType(type);
    },
  };
};

export default useSearchConfigController;
